import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../../../../Utils/API';
import { GET_EDIT_SUBACCOUNT_DETAILS, SUB_ACCOUNTS } from '../../../../Utils/GlobalConstants';
import { Button, Col, Form, Row, NavDropdown } from 'react-bootstrap';
import Toast from '../../../../GlobalComponents/Toast';
import styles from './editUser.module.scss';
import loadingGif from "../../../../Assets/Images/Animations/loading-management-console.gif"
import { TOAST_ERROR_ICON_COLOR, TOAST_SUCCESS_ICON_COLOR } from '../../../../Utils/ColorsConfiguration';
import { UserUpdationErrorToast, UserUpdationSuccessToast } from '../../../../Utils/StaticMessages/ToastMessages';
import { nameRegEx, phoneOnChangeRegex } from '../../../../Utils/RegExPatterns';

const EditUser = (props) => {
    const location = useLocation();                                                 // get Location
    const navigate = useNavigate();                                                 // to use navigate function from react router dom    
    const [subaccountDetails, setSubaccountDetails] = useState(null);               // store data from get api 
    const [defaultModuleDetails, setDefaultModuleDetails] = useState(null);         // store intial data of modules from get api 
    const [changedSelectedData, setChangedSelectedData] = useState([]);             // array used for manipulating value and used for put api for updation
    const [isDisabledForAllModule, setIsDisabledForAllModule] = useState(false);    // to check whether all modules are disabled or not so that on disable state we will show error
    const [firstName, setFirstName] = useState("");                                 // storing first name from get api
    const [lastName, setLastName] = useState("");                                   // storing last name from get api
    const [email, setEmail] = useState("");                                         // storing email id from get api
    const [phoneNumber, setPhoneNumber] = useState(null);                           // storing phone number from get api
    const [confirmLoadingFlag, setConfirmLoadingFlag] = useState(false);            // loading state for processing button

    // data in get profile api   
    const [id, setid] = useState(location.state !== null ? location.state.id : "");

    // Use State for Toasts
    const [toastSuccess, setToastSuccess] = useState(false);                        // toast message displaying success message
    const [toastError, setToastError] = useState(false);                            // toast message displaying error message
    const [toastMessage, setToastMessage] = useState("");                           // toast message  

    // Header Authorization for General API's
    const config = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
    };

    // Function to call account details (subaccount details)
    async function GetSubaccountDetails() {
        await api.get(`${GET_EDIT_SUBACCOUNT_DETAILS}${id}`, config)
            .then(resp => {
                setSubaccountDetails(resp.data);
                setFirstName(resp.data.firstName === null ? "" : resp.data.firstName);
                setLastName(resp.data.lastName === null ? "" : resp.data.lastName);
                setEmail(resp.data.email);
                setPhoneNumber(resp.data.phoneNumber === null ? "" : resp.data.phoneNumber);
                setChangedSelectedData(resp.data.userModuleFeatures);
                setDefaultModuleDetails(resp.data.userModuleFeatures);
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    props.Logout();
                }
                else {
                }
            });
    };

    //function called when there is any change in radio buttons for selection of options such as Readonly, read and write and disabled 
    function RoleSelectionCheck(moduleFeatureId, moduleName, isReadAccess, isReadWriteAccess, isDisabled) {
        let intermediateArray = [];
        changedSelectedData.map((selectedData) => {
            if (selectedData.moduleFeatureId === moduleFeatureId) {
                intermediateArray.push({
                    moduleFeatureId: moduleFeatureId,
                    moduleName: moduleName,
                    isReadAccess: isReadAccess !== undefined ? isReadAccess : selectedData.isReadAccess,
                    isReadWriteAccess: isReadWriteAccess !== undefined ? isReadWriteAccess : selectedData.isReadWriteAccess,
                    isDisabled: isDisabled !== undefined ? isDisabled : selectedData.isDisabled
                });
            } else {
                intermediateArray.push(selectedData);
            }
        });
        setChangedSelectedData(intermediateArray);

        // to check whether all modules are disabled or not
        let disabledConditionArray = [];
        changedSelectedData.map((selectedDataDisabledState) => {
            // excluding profile module here as it is always read and write
            if (selectedDataDisabledState.moduleFeatureId != 9) {
                if (selectedDataDisabledState.moduleFeatureId === moduleFeatureId) {
                    disabledConditionArray.push(isDisabled)
                }
                else
                    disabledConditionArray.push(selectedDataDisabledState.isDisabled)
            }
        })

        if (disabledConditionArray.includes(false)) {
            setIsDisabledForAllModule(false)
        } else {
            setIsDisabledForAllModule(true);
        }
    }

    // put api for updation
    async function UpdateUserDetails() {
        setConfirmLoadingFlag(true);
        const requestBody = {
            "id": id,
            "firstName": firstName,
            "lastName": lastName,
            "userName": subaccountDetails.userName,
            "email": email,
            "phoneNumber": phoneNumber,
            "userModuleFeatures": changedSelectedData
        };
        await api.put(SUB_ACCOUNTS, requestBody, config)
            .then(resp => {
                if (resp.status == 200) {
                    setToastMessage(UserUpdationSuccessToast)
                    setToastSuccess(true);
                    setTimeout(() => {
                        setToastSuccess(false);
                        setConfirmLoadingFlag(false);
                        navigate("/user-management");
                    }, 5000);
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    props.Logout();
                }
                else {
                    setToastMessage(UserUpdationErrorToast);
                    setToastError(true);
                    setTimeout(() => {
                        setConfirmLoadingFlag(false);
                        setToastError(false);
                    }, 5000);
                }
            });
    }

    // Use Effect to get the account details (subaccount details) pre-filled in the form.
    useEffect(() => {
        GetSubaccountDetails();
        // Scroll to Top on Initial loading
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Toast toastSetUseState={setToastSuccess} toastCheckUseState={toastSuccess} toastType="success" toastIconColor={TOAST_SUCCESS_ICON_COLOR} toastMessage={toastMessage} />
            <Toast toastSetUseState={setToastError} toastCheckUseState={toastError} toastType="danger" toastIconColor={TOAST_ERROR_ICON_COLOR} toastMessage={toastMessage} />

            <div className='main-content'>
                <div className="customer-management-console-main-div mb-5">
                    <div className="mgmt-console-table-row">
                        <div className="my-3 d-flex">
                            <Col className={`py-0 ${styles['profile-table']}`}>

                                <Row className="align-items-center">
                                    <label className="cpointer" onClick={() => navigate('/user-management')}>
                                        <span className="back">&nbsp;</span>&nbsp;<strong>{subaccountDetails && (subaccountDetails.userName + " (" + subaccountDetails.firstName + " " + subaccountDetails.lastName + ")")}</strong>
                                    </label>
                                </Row>
                                <div className='cloud-invoice-table-inner table-details details-box'>
                                    <div className="my-0 table-heading align-items-center row">
                                        <Col className='pl-1'>
                                            <Row className='px-3 py-2'>
                                                <h2 className='pb-2'>User Details</h2>
                                                <Col lg={4} md={5}>
                                                    <Form.Group className="mb-3" controlId="firstName">
                                                        <Form.Label >First Name <span className="red">*</span></Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={firstName}
                                                            maxlength="50"
                                                            name="firstName"
                                                            onChange={(e) => {
                                                                if (e.target.value === '' || nameRegEx.test(e.target.value)) {
                                                                    setFirstName(e.target.value);
                                                                }
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4} md={5}>
                                                    <Form.Group className="mb-3" controlId="lastName">
                                                        <Form.Label >Last Name <span className="red">*</span></Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="lastName"
                                                            value={lastName}
                                                            maxlength="50"
                                                            onChange={(e) => {
                                                                if (e.target.value === '' || nameRegEx.test(e.target.value)) {
                                                                    setLastName(e.target.value);
                                                                }
                                                            }} />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={12}></Col>

                                                <Col lg={4} md={5}>
                                                    <Form.Group className="mb-3" controlId="Email">
                                                        <Form.Label >Email ID <span className="red">*</span></Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            name="Email"
                                                            value={email}
                                                            readOnly
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4} md={5}>
                                                    <Form.Group className="mb-3" controlId="phoneNumber">
                                                        <Form.Label >
                                                            Phone Number <span className="red">*</span>
                                                        </Form.Label>
                                                        <Row>
                                                            <Col>
                                                                <div className="phone-number-wrapper">
                                                                    <label>+61</label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        className="phone-number form-control col"
                                                                        placeholder="xxxxxxxxxx"
                                                                        name="phoneNumber"
                                                                        value={phoneNumber}
                                                                        maxLength="15"
                                                                        onChange={(e) => {
                                                                            const inputValue = e.target.value;
                                                                            if (inputValue === '' || phoneOnChangeRegex.test(inputValue)) {
                                                                                setPhoneNumber(inputValue);
                                                                            }
                                                                        }
                                                                        }
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={12}></Col>
                                            </Row>
                                        </Col>
                                        <Row className='px-3 mb-4'>
                                            {subaccountDetails && <Col lg={4} md={6}>
                                                <h2 className='pb-2'>Role Settings</h2>
                                                <Form.Group >
                                                    <Form.Label>Role<span className="red">*</span></Form.Label>
                                                    <NavDropdown title={subaccountDetails ? subaccountDetails.currentRole : "Loading ..."} id="cloud-service-dropdown"
                                                        className={`servcies-dropdown ${styles['dropdown-disabled']}`} disabled>
                                                    </NavDropdown>
                                                    {isDisabledForAllModule && <span className="red text-small">Select either "Read only" or "Read &amp; Write" access for at least one module.</span>}

                                                </Form.Group>
                                            </Col>}
                                        </Row>
                                        {
                                            subaccountDetails === null &&
                                            <div className={styles["no-data-cloud-invoice"]}>
                                                <img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading ...</p>
                                            </div>
                                        }
                                        {subaccountDetails && subaccountDetails.userModuleFeatures.map((role) => {
                                            return (
                                                <Row className="my-2 pl-4">
                                                    <Col md={2}>
                                                        <span className='text-strong'>{role.moduleName} <span className="red">*</span> :</span>
                                                    </Col>
                                                    {role.moduleName != "Profile" && <>
                                                        <Col md={2}>
                                                            <Form.Check
                                                                type="radio"
                                                                id="ReadOnly"
                                                                label={`Read only`}
                                                                name={role.moduleName}
                                                                defaultChecked={role.isReadAccess}
                                                                onClick={() => {
                                                                    RoleSelectionCheck(role.moduleFeatureId, role.moduleName, true, false, false);
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col md={2}>
                                                            <Form.Check
                                                                type="radio"
                                                                id="ReadAndWrite"
                                                                label={`Read & write`}
                                                                name={role.moduleName}
                                                                defaultChecked={role.isReadWriteAccess}
                                                                onClick={() => {
                                                                    RoleSelectionCheck(role.moduleFeatureId, role.moduleName, false, true, false);
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col md={2}>
                                                            <Form.Check
                                                                type="radio"
                                                                id="Disable"
                                                                label={`Disable`}
                                                                name={role.moduleName}
                                                                defaultChecked={role.isDisabled}
                                                                onClick={() => {
                                                                    RoleSelectionCheck(role.moduleFeatureId, role.moduleName, false, false, true);
                                                                }}
                                                            />
                                                        </Col>
                                                    </>}
                                                    {role.moduleName === "Profile" &&
                                                        <Col md={2}>
                                                            <span>Read & write</span>
                                                        </Col>
                                                    }
                                                </Row>
                                            )
                                        })}

                                        {subaccountDetails && subaccountDetails.userModuleFeatures && <Row>
                                            <Col className="my-3 text-right btn-wrapper-outer">
                                                {!confirmLoadingFlag && <Button
                                                    className="ml-3 btn-border-light w-md-auto col-xs-12 mb-3"
                                                    variant="light"
                                                    onClick={() => {
                                                        navigate('/user-management')
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                                }
                                                {
                                                    isDisabledForAllModule && !confirmLoadingFlag &&
                                                    <Button
                                                        className="ml-3 w-md-auto btn-light col-xs-12 mb-3"
                                                        variant='light'
                                                        disabled
                                                    >
                                                        Save
                                                    </Button>
                                                }
                                                {
                                                    ((firstName === "" || lastName === "" || phoneNumber === null || phoneNumber === "" || (phoneNumber?.length < 8 || phoneNumber?.length > 15) || email === "") || !(subaccountDetails.firstName != firstName || subaccountDetails.lastName != lastName || subaccountDetails.phoneNumber != phoneNumber || JSON.stringify(defaultModuleDetails) != JSON.stringify(changedSelectedData)) && !isDisabledForAllModule && !confirmLoadingFlag) &&
                                                    <Button
                                                        className="ml-3 w-md-auto btn-light col-xs-12 mb-3"
                                                        variant='light'
                                                        disabled
                                                    >
                                                        Save
                                                    </Button>
                                                }

                                                {
                                                    ((firstName != "" && lastName != "" && (phoneNumber?.length >=8 && phoneNumber?.length <=15) && email != "") && (subaccountDetails.firstName != firstName || subaccountDetails.lastName != lastName || subaccountDetails.phoneNumber != phoneNumber || JSON.stringify(defaultModuleDetails) != JSON.stringify(changedSelectedData)) && !isDisabledForAllModule && !confirmLoadingFlag) &&
                                                    <Button
                                                        className="ml-3 w-md-auto col-xs-12 mb-3"
                                                        onClick={() => {
                                                            UpdateUserDetails();
                                                        }}
                                                    >
                                                        Save
                                                    </Button>
                                                }
                                                {
                                                    confirmLoadingFlag &&
                                                    <>
                                                        <Button
                                                            variant="light"
                                                            disabled
                                                            className="px-4 mx-2 btn-border-light w-md-auto col-xs-12"
                                                        >Cancel
                                                        </Button>
                                                        <Button
                                                            disabled
                                                            className="ml-3 btn-border-light w-md-auto col-xs-12"
                                                            variant="light"
                                                        >
                                                            Processing . . .
                                                        </Button>
                                                    </>
                                                }
                                            </Col>
                                        </Row>}
                                    </div>
                                </div>
                            </Col>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditUser